module.exports = __webpack_public_path__ + "static/media/ar.621fdc81.png";